/**
 * removes empty value objects from the list provided
 *
 * @param {array} list of objects {value:'xyz'}
 * @returns {array} that has the empty value object(s) removed
 */
export const stripEmptyValues = list =>
  list.filter(item => item.value !== null && String(item.value).trim() !== '');
